<!-- QR認証成功 -->
<template>
  <ItemDialog ref="DialogValidFramesWithQRComplete" imageType="done">
    <template v-slot:content-area>
      <h2>
        {{ $t("MyTicketTicketing.QRSuccess.title") }}
      </h2>
      <p class="text-center">
        {{ $t("MyTicketTicketing.QRSuccess.description") }}
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        :label="$t('MyTicketTicketing.ticketDetails')"
        actionType="btn-primary"
        @clicked="goToSheet"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "DialogValidFramesWithQRComplete",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogValidFramesWithQRComplete = ref(null);
    const book = store.getters["ticketing/book"];
    const sheet = store.getters["ticketing/sheet"];

    const openDialog = () => {
      DialogValidFramesWithQRComplete.value.open();
    };

    const closeDialog = () => {
      DialogValidFramesWithQRComplete.value.close();
    };

    const goToSheet = () => {
      let query = { language: store.getters["common/lang"] };

      const issuedExternalCouponStatusOfSheet = store.getters["ticketing/issuedExternalCouponStatusOfSheet"];
      if(issuedExternalCouponStatusOfSheet != null)
      {
        query.issuedExternalCoupon = issuedExternalCouponStatusOfSheet ? 1 : 0;
      }

      router.push({
        name: "Sheet",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: book.id,
          master_sheet_id: sheet.master_sheet_id,
          sheet_id: String(sheet.id),
        },
        query: query,
      });
    };

    return {
      DialogValidFramesWithQRComplete,
      openDialog,
      closeDialog,
      goToSheet,
    };
  },
};
</script>
